import React from 'react';
import Datatable from '../../../core/common/dataTable';

interface Employee {
    user_id: number;
    name: string;
    email: string;
    phone: string;
    profile_pic: string;
    department_name: string;
}

interface EmployeeDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    users: Employee[];
    designation: string;
}

const EmployeeDetailsModal: React.FC<EmployeeDetailsModalProps> = ({
    isOpen,
    onClose,
    users,
    designation
}) => {
    if (!isOpen) return null;

    const columns = [
        {
            title: 'Profile',
            dataIndex: 'profile_pic',
            key: 'profile',
            render: (profile_pic: string, record: Employee) => (
                <div style={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img
                        src={profile_pic || "/assets/img/avatar.jpg"}
                        alt={record.name}
                        style={{
                            width: '40px',
                            height: '40px',
                            objectFit: 'cover',
                            border: '2px solid #e9ecef',
                            borderRadius: '50%'
                        }}
                        onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = "/assets/img/avatar.jpg";
                        }}
                    />
                </div>
            ),
            width: 80
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name: string) => <strong>{name}</strong>,
            sorter: (a: any, b: any) => a.name.localeCompare(b.name)
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (email: string) => (
                <span style={{ color: '#495057' }}>
                    {email || '-'}
                </span>
            ),
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (phone: string) => (
                phone ? (
                    <a
                        href={`tel:${phone}`}
                        style={{
                            color: '#212529',
                            textDecoration: 'none'
                        }}
                    >
                        {phone}
                    </a>
                ) : (
                    <span style={{ color: '#6c757d' }}>N/A</span>
                )
            )
        },
        {
            title: 'Department',
            dataIndex: 'department_name',
            key: 'department',
            render: (department: string) => (
                <span style={{
                    backgroundColor: 'rgba(13, 202, 240, 0.1)',
                    color: '#0dcaf0',
                    fontWeight: 500,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.875rem'
                }}>
                    {department}
                </span>
            )
        }
    ];

    return (
        <>
            {/* Modal */}
            <div
                className={`modal fade ${isOpen ? 'show' : ''}`}
                style={{
                    display: isOpen ? 'block' : 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 1055
                }}
                tabIndex={-1}
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{
                        border: 'none',
                        borderRadius: '10px',
                        boxShadow: '0 5px 20px rgba(0, 0, 0, 0.1)'
                    }}>
                        <div className="modal-header" style={{
                            backgroundColor: '#f8f9fa',
                            borderBottom: '1px solid #e9ecef',
                            borderRadius: '10px 10px 0 0',
                            padding: '1rem 1.5rem'
                        }}>
                            <h4 className="modal-title" style={{
                                color: '#343a40',
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                Employees - {designation}
                                <span className="badge badge-primary ms-2">
                                    {users.length} {users.length === 1 ? 'Employee' : 'Employees'}
                                </span>
                            </h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>

                        <div className="modal-body p-0">
                            {users.length > 0 ? (
                                <div className="card-body">
                                    <Datatable
                                        key={JSON.stringify(users)}
                                        dataSource={users}
                                        columns={columns}
                                        Selection={false}
                                    />
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="mb-3">
                                        <i className="ti ti-users fs-1 text-muted" />
                                    </div>
                                    <h5 className="text-muted">No employees found</h5>
                                    <p className="text-muted mb-0">
                                        There are no employees assigned to this designation.
                                    </p>
                                </div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <div className="d-flex justify-content-between w-100">
                                <div>
                                    <span className="text-muted fs-12">
                                        Showing {users.length} of {users.length} employees
                                    </span>
                                </div>
                                <div>
                                    {/* <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onClose}
                                    >
                                        Close
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="modal-backdrop fade show"
                style={{
                    zIndex: 1050,
                    opacity: 0.5,
                    backgroundColor: '#000',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh'
                }}
                onClick={onClose}
            ></div>
        </>
    );
};

export default EmployeeDetailsModal;